<template>
  <div class="g-wrap">
    <div class="page-volunteer">
      <div class="page-volunteer-content">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
}
</script>

<style lang="scss" scoped>
.g-wrap {
  display: flex;
  width: 100%;
  .page-volunteer {
    position: relative;
    flex: 1;
    overflow: hidden auto;
  }
}
</style>


